import React from 'react';
import '../styles/App.css';
import Sidebar from '../components/sidemenu/sidebar';
import CrudTable from '../components/cruds/formularioPolizas';

const formulario_polizas = () => {
  return (
    <div>
        <Sidebar/>
        <div>
            <h3 className="title">Formulario Pólizas</h3>
        </div>
        <CrudTable/>
    </div>
  );


};

export default formulario_polizas;